/* rails-erb-loader-dependencies config/initializers/constants.rb */
export const SINGLE_PRICE = 29;
export const LABEL_REVIEW_PRICE = 60;
export const FULL_LABEL_REVIEW_PRICE = 150;
